import gameActiveImage from '../img/games_active.png'
import gameInactiveImage from '../img/games_inactive.png'

import casinoActiveImage from '../img/casino_active.png'
import promoActiveCasinoImage from '../img/promo_active_casino.png'
import casinoInactiveImage from '../img/casino_inactive.png'
import promoInactiveImage from '../img/promo_inactive.png'
import '../css/bottom_menu.css'
import streamImage from '../img/stream.png'
import { useLocation, useNavigate } from 'react-router-dom';


function BottomMenuCasino({activeSubcategory, setActiveSubcategory, countryName, phoneNumber}) {
    const location = useLocation();
    const navigate = useNavigate();

    return (
        <div className="bottom-menu">
            <div className="bottom-menu-item-container">
                <div className="bottom-menu-item-image-container" onClick={() => {
                    setActiveSubcategory('Игры')
                    if (location.pathname === '/news' || location.pathname === '/profile' || location.pathname === '/user-images'){
                        navigate(`/?phone=${phoneNumber}`)
                    }
                    }}>
                    <img className="bottom-menu-item-image" src = {activeSubcategory === 'Игры' ? gameActiveImage : gameInactiveImage } alt='error'/>
                </div>
                <div className='bottom-menu-item-title' style={{color: '#FFFFFF'}}> {countryName === 'russia' ? 'Игры': 'Games'}</div>
            </div>
            <div className="bottom-menu-item-container" onClick={() => {
                setActiveSubcategory('Казино')
                if (location.pathname === '/news' || location.pathname === '/profile' || location.pathname === '/user-images'){
                    navigate(`/?phone=${phoneNumber}`)
                }
            }}>
                <div className="bottom-menu-item-image-container">
                    <img className="bottom-menu-item-image" src = {activeSubcategory === 'Казино' ? casinoActiveImage : casinoInactiveImage } alt='error'/>
                </div>
                <div className='bottom-menu-item-title' style={{color: '#FFFFFF'}}>{countryName === 'russia' ? 'Казино': 'Casino'}</div>
            </div>
            <div className="bottom-menu-item-container" onClick={() => {
                setActiveSubcategory('Сообщество')
                if (location.pathname === '/news' || location.pathname === '/profile' || location.pathname === '/user-images'){
                        navigate(`/?phone=${phoneNumber}`)
                    }}}>
                <div className="bottom-menu-item-image-container">
                    <img className="bottom-menu-item-image" src = {activeSubcategory === 'Сообщество' ? promoActiveCasinoImage : promoInactiveImage } alt='error'/>
                </div>
                <div className='bottom-menu-item-title' style={{color: '#FFFFFF'}}>{countryName === 'russia' ? 'Сообщество': 'Community'}</div>
            </div>
            <div className="bottom-menu-item-container">
                <div className="bottom-menu-item-image-container" onClick={() => window.open('https://kick.com/category/slots', '_self')}>
                    <img className="bottom-menu-item-image" src = {streamImage} alt='error'/>
                </div>
                <div className='bottom-menu-item-title' style={{color: '#FFFFFF'}}> {countryName === 'russia' ? 'Стримы': 'Streams'}</div>
            </div>

        </div>
    )

};

export default BottomMenuCasino;